const DeleteModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h2 className="modal-title">
          {title || "Delete Item"}
        </h2>

        <p className="modal-message">
          {message || "Are you sure you want to delete this item?"}
        </p>

        <div className="modal-actions">
          <button className="btn cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="btn delete-btn" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;